import { render, staticRenderFns } from "./DictionarySpecifications.vue?vue&type=template&id=1573286e&"
import script from "./DictionarySpecifications.vue?vue&type=script&lang=js&"
export * from "./DictionarySpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports